import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';

import { ToastAction } from 'src/app/shared/toast/toast.types';

export enum MessageType {
  primary = 'primary',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  info = 'info'
}

export interface NotificationType {
  id: string;
  scope: string;
  isClose: boolean;
  type: MessageType;
  message: string;
  /**
   * The following fields are only populated for global toasts. They are
   * optional so existing scoped-banner consumers stay untouched and keep
   * ignoring them — a backward-compatible, additive change to the store.
   */
  title?: string;
  action?: ToastAction;
  duration?: number;
}

export type NotificationState = EntityState<NotificationType>;

const getInitialState = () => ({});

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: 'Notification' })
export class NotificationStore extends EntityStore<NotificationState, NotificationType> {
  constructor() {
    super(getInitialState());
  }
}
